











































































































import moment from 'moment';
import Vue from 'vue';
import { fetchConfiguracionStreamax } from './../../Streamax/fetchConfiguracionStreamax';
import { AxiosVue } from '@/AxiosVue'; //
import { LoadingService } from '@/services/loadingService';
import { ServicioProxy } from '@/config/enums'; //
import { Component, Prop } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import { EstadoEntidad } from '@/config/enums';
import Confirmation from '@/components/Confirmation.vue'; //
import { TranslateResult } from 'vue-i18n';
import { GridApi } from 'ag-grid-community';
import { consoleSandbox } from '@sentry/utils';
@Component({
  components: {
    'app-confirmacion': Confirmation,
  },
})
export default class FormEditarPowerHowen extends Vue {
  @Prop({ default: false }) edited!: any;
  @Prop({ default: false }) esEdicion!: boolean;
  @Prop({ default: {} }) selectedValue: any;
  accion!: any;
  ordesList2: any;
  data: any = {};
  hora: any;
  show1: any = false;
  async getTimeSeleccionado() {
    let self = this;
    this.loadingService.showLoading();
    return fetchConfiguracionStreamax(
      { id_camara: this.selectedValue },
      'configCamaras/getConfCamaraDialupHowen'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.loadingService.hideLoading();
          return data.data.data.LISTA;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.loadingService.hideLoading();
          return [];
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
        this.loadingService.hideLoading();
      });
  }
  async getTime() {
    this.ordesList2 = (await this.getTimeSeleccionado()) || [];
    this.data = this.ordesList2[0];
    this.formFields.enable.value = parseInt(this.data['?column?'].switch);
    this.formFields.type.value = parseInt(this.data['?column?'].type);
    this.formFields.apn.value = this.data['?column?'].apn;
    this.formFields.serverCode.value = this.data['?column?'].servercode;
    this.formFields.user.value = this.data['?column?'].user;
    this.formFields.password.value = this.data['?column?'].passwd;
  }
  mounted() {
    this.getTime();
  }
  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
    console.log(this.formFields);
  }
  onSelectionChanged(params: any) {}
  formFields: {
    enable: any;
    type: any;
    apn: any;
    serverCode: any;
    user: any;
    password: any;
  } = {
    enable: {
      label: 'Enable',
      value: 0,
      items: [{ label: 'Off', id: 0 }, { label: 'On', id: 1 }],
    },
    type: {
      label: 'Type',
      value: 0,
      items: [
        { label: 'WCDMA', id: 0 },
        { label: 'EVDO', id: 1 },
        { label: 'TD-SCDMA', id: 2 },
        { label: 'TDD-LTE', id: 3 },
        { label: 'FDD-1()', id: 4 },
        { label: 'FDD-2()', id: 5 },
      ],
    },
    apn: {
      label: 'APN',
      value: '',
      items: [
        { label: 'm2m.movistar.cl', id: 'm2m.movistar.cl' },
        { label: 'imovil.entelpcs.cl', id: 'imovil.entelpcs.cl' },
      ],
    },
    serverCode: {
      label: 'Server Code',
      value: '',
    },
    user: {
      label: 'User',
      value: '',
    },
    password: {
      label: 'Password',
      value: '',
    },
  };
  selectedEnable() {
    return this.formFields.enable.items.find(
      (item: { id: any }) => item.id === this.formFields.enable.value
    );
  }
  selectedType() {
    return this.formFields.type.items.find(
      (item: { id: any }) => item.id === this.formFields.type.value
    );
  }
  selectedApn() {
    return this.formFields.apn.items.find(
      (item: { id: any }) => item.id === this.formFields.apn.value
    );
  }
  //abstract
  readonly funcionalidad: Funcionalidades = Funcionalidades.Streamax;
  //propiedades globales
  loadingService = new LoadingService();
  gridApi: GridApi;
  $snotify: any;
  dialog: boolean = true;
  dialogConfirmacionClose: boolean = false;
  bottomNav: any = '1';
  dictionaryFormErrors: any = {};
  validForm: boolean = false;
  dialogConfirmacion: boolean = false;
  btnBloquear: Boolean = false;
  //Interface
  estadoSwitch: boolean = false;
  //controllers
  readonly controller: string = 'funcionalidad';
  readonly controllerAccion: string = 'accion';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);
}
